import React, { Component } from "react";
import { createOperationIcon } from '@platform/api';
import { Checkbox, Tooltip } from '@platform/base';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
export default class HistoryRecord extends Component {
    constructor (props) {
        super(props);
        this.state = { tipRender:false };
         
    }
    
    formatDate = time=>{
        let { locale } = this.props;
        let date = new Date(),
            year = date.getFullYear(),
            month = date.getMonth() + 1,
            day = date.getDate();
         
        month = (month > 9) ? month : ("0" + month);
        day = (day < 10) ? ("0" + day) : day;
        let today = year + "-" + month + "-" + day;
        let [time_day, time_hms] = time.split(' '); 
        let [, searchMonth, searchDay] = time_day.split("-");
        let [hour, min] = time_hms.split(':'); //时分秒 hh:mm:ss
        if(time_day===today) {
            return `${locale['table_today']/*今天*/} ${hour}:${min}`;
        } else {
            return `${searchMonth}-${searchDay} ${hour}:${min}`; 
        }
    } 
    
    render () {
        let { records:iniRecords, onSearch, searchTime, isDisabled, locale, queryrelationinfo, wrapperWidth, cardLength, emptySearchCallBack } = this.props;
        let dateTypes = new Set([
            'datepicker', 
            'datetimepicker', 
            'rangepicker', 
            'datePickerNoTimeZone',
            'NCTZDatePickerRangeDay',
            'NCTZDatePickClientHourTime',
            'NCTZDatePickClientTime',
        ]);
        
        let records = JSON.parse(JSON.stringify(iniRecords));
        //给record添加类型，根据不同的类型显示不同的界面
        records.forEach(record => {
            //queryrelationinfo存在这种数据结构[null]
            record.type = queryrelationinfo.find(item=> item?.attrcode===record.field)?.itemtype;
            let { type='', value={} } = record;
            if (type.indexOf('switch')!==-1 ) { //switch  checkbox_switch 类型
                record.display = <Checkbox disabled checked = {value.firstvalue}></Checkbox>;   
            } else if (dateTypes.has(type)) { //日期组件
                record.display = record.display.toString().replace(',', '~');     
            }
        });
        if(!records.length) {
            queryrelationinfo.forEach((item,index)=>{
                  records.push (
                     {
                        field:item.attrcode,
                        originOptSign: item.originOptSign,
                        def5: item.label,
                     }
                  ) 
            })
        }
        return <div onClick={()=>{
            if(!isDisabled){
                onSearch(records);
                emptySearchCallBack?.(records);
            }}
        }
        className={`history-card ${isDisabled? 'history-card-disabled':''}`}>
            {isDisabled &&
            <div className="record-disabled">
                <div className="record-disabled-tips">{locale['table_record_disabled']}</div>
            </div>} 
            <div className="card-header">
                <div className="header-left">{this.formatDate(searchTime)}</div>
                <i className=" iconfont icon-gerenzhongxin-canshuxiala header-right" />  
            </div>
            <div className={classnames({
                content:true,
                content_3:wrapperWidth<950 && cardLength===3,
                content_4:wrapperWidth<950 && cardLength===4,
            })}>
                {
                    records.map( (record, index) =>{
                        let { field, def5, originOptSign, display, displayHeight } = record;
                        return <div className="item" 
                            key = {field}
                        >
                            <span className="title">{def5}{createOperationIcon(originOptSign)}:</span>
                            <Tooltip overlay={ this.state.tipRender ? display : '' }>
                                <span className="value"
                                    onMouseEnter={()=>{
                                    let tipRender = ReactDOM.findDOMNode(this)?.querySelector(`.value-index${index}`)?.scrollHeight>51; 
                                    this.setState({tipRender})    
                                }}
                                >
                                    <span className={`center ellipsis value-index${index}`}>
                                        {display}
                                    </span>
                                </span>
                            </Tooltip>
                        </div>;
                    })
                }
            </div>
            
        </div>;
    }
}